export enum ActionType {
  FETCH_USER_LIST_REQUESTED = 'FETCH_USER_LIST_REQUESTED',
  FETCH_USER_LIST_STARTED = 'FETCH_USER_LIST_STARTED',
  FETCH_USER_LIST_SUCCEEDED = 'FETCH_USER_LIST_SUCCEEDED',
  FETCH_USER_LIST_FAILED = 'FETCH_USER_LIST_FAILED',

  FETCH_VARIABLE_LIST_REQUESTED = 'FETCH_VARIABLE_LIST_REQUESTED',
  FETCH_VARIABLE_LIST_STARTED = 'FETCH_VARIABLE_LIST_STARTED',
  FETCH_VARIABLE_LIST_SUCCEEDED = 'FETCH_VARIABLE_LIST_SUCCEEDED',
  FETCH_VARIABLE_LIST_FAILED = 'FETCH_VARIABLE_LIST_FAILED',

  FETCH_VARIABLE_REQUESTED = 'FETCH_VARIABLE_REQUESTED',
  FETCH_VARIABLE_STARTED = 'FETCH_VARIABLE_STARTED',
  FETCH_VARIABLE_SUCCEEDED = 'FETCH_VARIABLE_SUCCEEDED',
  FETCH_VARIABLE_FAILED = 'FETCH_VARIABLE_FAILED',

  CREATE_VARIABLES_REQUESTED = 'CREATE_VARIABLES_REQUESTED',
  CREATE_VARIABLES_STARTED = 'CREATE_VARIABLES_STARTED',
  CREATE_VARIABLES_SUCCEEDED = 'CREATE_VARIABLES_SUCCEEDED',
  CREATE_VARIABLES_FAILED = 'CREATE_VARIABLES_FAILED',

  UPDATE_VARIABLES_REQUESTED = 'UPDATE_VARIABLES_REQUESTED',
  UPDATE_VARIABLES_STARTED = 'UPDATE_VARIABLES_STARTED',
  UPDATE_VARIABLES_SUCCEEDED = 'UPDATE_VARIABLES_SUCCEEDED',
  UPDATE_VARIABLES_FAILED = 'UPDATE_VARIABLES_FAILED',

  FETCH_EXPERIMENTS_REQUESTED = 'FETCH_EXPERIMENTS_REQUESTED',
  FETCH_EXPERIMENTS_STARTED = 'FETCH_EXPERIMENTS_STARTED',
  FETCH_EXPERIMENTS_SUCCEEDED = 'FETCH_EXPERIMENTS_SUCCEEDED',
  FETCH_EXPERIMENTS_FAILED = 'FETCH_EXPERIMENTS_FAILED',

  // TODO: ask to keep medatada in experiments response instead of calling separated api
  FETCH_EXPERIMENT_REQUESTED = 'FETCH_EXPERIMENT_REQUESTED',
  FETCH_EXPERIMENT_STARTED = 'FETCH_EXPERIMENT_STARTED',
  FETCH_EXPERIMENT_SUCCEEDED = 'FETCH_EXPERIMENT_SUCCEEDED',
  FETCH_EXPERIMENT_FAILED = 'FETCH_EXPERIMENT_FAILED',

  CREATE_EXPERIMENT_REQUESTED = 'CREATE_EXPERIMENT_REQUESTED',
  CREATE_EXPERIMENT_STARTED = 'CREATE_EXPERIMENT_STARTED',
  CREATE_EXPERIMENT_SUCCEEDED = 'CREATE_EXPERIMENT_SUCCEEDED',
  CREATE_EXPERIMENT_FAILED = 'CREATE_EXPERIMENT_FAILED',

  UPDATE_EXPERIMENT_REQUESTED = 'UPDATE_EXPERIMENT_REQUESTED',
  UPDATE_EXPERIMENT_STARTED = 'UPDATE_EXPERIMENT_STARTED',
  UPDATE_EXPERIMENT_SUCCEEDED = 'UPDATE_EXPERIMENT_SUCCEEDED',
  UPDATE_EXPERIMENT_FAILED = 'UPDATE_EXPERIMENT_FAILED',

  FETCH_EVENTS_REQUESTED = 'FETCH_EVENTS_REQUESTED',
  FETCH_EVENTS_STARTED = 'FETCH_EVENTS_STARTED',
  FETCH_EVENTS_SUCCEEDED = 'FETCH_EVENTS_SUCCEEDED',
  FETCH_EVENTS_FAILED = 'FETCH_EVENTS_FAILED',

  UPDATE_EVENTS_REQUESTED = 'UPDATE_EVENTS_REQUESTED',
  UPDATE_EVENTS_STARTED = 'UPDATE_EVENTS_STARTED',
  UPDATE_EVENTS_SUCCEEDED = 'UPDATE_EVENTS_SUCCEEDED',
  UPDATE_EVENTS_FAILED = 'UPDATE_EVENTS_FAILED',

  FETCH_LATEST_ROLLOUT_REQUESTED = 'FETCH_LATEST_ROLLOUT_REQUESTED',
  FETCH_LATEST_ROLLOUT_STARTED = 'FETCH_LATEST_ROLLOUT_STARTED',
  FETCH_LATEST_ROLLOUT_SUCCEEDED = 'FETCH_LATEST_ROLLOUT_SUCCEEDED',
  FETCH_LATEST_ROLLOUT_FAILED = 'FETCH_LATEST_ROLLOUT_FAILED',

  FETCH_ROLLOUT_HISTORY_REQUESTED = 'FETCH_ROLLOUT_HISTORY_REQUESTED',
  FETCH_ROLLOUT_HISTORY_STARTED = 'FETCH_ROLLOUT_HISTORY_STARTED',
  FETCH_ROLLOUT_HISTORY_SUCCEEDED = 'FETCH_ROLLOUT_HISTORY_SUCCEEDED',
  FETCH_ROLLOUT_HISTORY_FAILED = 'FETCH_ROLLOUT_HISTORY_FAILED',

  FETCH_ROLLOUT_VERSION_REQUESTED = 'FETCH_ROLLOUT_VERSION_REQUESTED',
  FETCH_ROLLOUT_VERSION_STARTED = 'FETCH_ROLLOUT_VERSION_STARTED',
  FETCH_ROLLOUT_VERSION_SUCCEEDED = 'FETCH_ROLLOUT_VERSION_SUCCEEDED',
  FETCH_ROLLOUT_VERSION_FAILED = 'FETCH_ROLLOUT_VERSION_FAILED',

  FETCH_CAMPAIGN_LIST_REQUESTED = 'FETCH_CAMPAIGN_LIST_REQUESTED',
  FETCH_CAMPAIGN_LIST_STARTED = 'FETCH_CAMPAIGN_LIST_STARTED',
  FETCH_CAMPAIGN_LIST_SUCCEEDED = 'FETCH_CAMPAIGN_LIST_SUCCEEDED',
  FETCH_CAMPAIGN_LIST_FAILED = 'FETCH_CAMPAIGN_LIST_FAILED',

  FETCH_CAMPAIGN_REQUESTED = 'FETCH_CAMPAIGN_REQUESTED',
  FETCH_CAMPAIGN_STARTED = 'FETCH_CAMPAIGN_STARTED',
  FETCH_CAMPAIGN_SUCCEEDED = 'FETCH_CAMPAIGN_SUCCEEDED',
  FETCH_CAMPAIGN_FAILED = 'FETCH_CAMPAIGN_FAILED',

  FETCH_EXPERIMENTS_BY_VARIABLE_REQUESTED = 'FETCH_EXPERIMENTS_BY_VARIABLE_REQUESTED',
  FETCH_EXPERIMENTS_BY_VARIABLE_STARTED = 'FETCH_EXPERIMENTS_BY_VARIABLE_STARTED',
  FETCH_EXPERIMENTS_BY_VARIABLE_SUCCEEDED = 'FETCH_EXPERIMENTS_BY_VARIABLE_SUCCEEDED',
  FETCH_EXPERIMENTS_BY_VARIABLE_FAILED = 'FETCH_EXPERIMENTS_BY_VARIABLE_FAILED',

  FETCH_TRIGGER_EVENTS_REQUESTED = 'FETCH_TRIGGER_EVENTS_REQUESTED',
  FETCH_TRIGGER_EVENTS_STARTED = 'FETCH_TRIGGER_EVENTS_STARTED',
  FETCH_TRIGGER_EVENTS_SUCCEEDED = 'FETCH_TRIGGER_EVENTS_SUCCEEDED',
  FETCH_TRIGGER_EVENTS_FAILED = 'FETCH_TRIGGER_EVENTS_FAILED',

  FETCH_TEMPLATES_LIST_REQUESTED = 'FETCH_TEMPLATES_LIST_REQUESTED',
  FETCH_TEMPLATES_LIST_STARTED = 'FETCH_TEMPLATES_LIST_STARTED',
  FETCH_TEMPLATES_LIST_SUCCEEDED = 'FETCH_TEMPLATES_LIST_SUCCEEDED',
  FETCH_TEMPLATES_LIST_FAILED = 'FETCH_TEMPLATES_LIST_FAILED',

  FETCH_TEMPLATE_REQUESTED = 'FETCH_TEMPLATE_REQUESTED',
  FETCH_TEMPLATE_STARTED = 'FETCH_TEMPLATE_STARTED',
  FETCH_TEMPLATE_SUCCEEDED = 'FETCH_TEMPLATE_SUCCEEDED',
  FETCH_TEMPLATE_FAILED = 'FETCH_TEMPLATE_FAILED',

  CREATE_CAMPAIGN_REQUESTED = 'CREATE_CAMPAIGN_REQUESTED',
  CREATE_CAMPAIGN_STARTED = 'CREATE_CAMPAIGN_STARTED',
  CREATE_CAMPAIGN_SUCCEEDED = 'CREATE_CAMPAIGN_SUCCEEDED',
  CREATE_CAMPAIGN_FAILED = 'CREATE_CAMPAIGN_FAILED',

  UPDATE_CAMPAIGN_REQUESTED = 'UPDATE_CAMPAIGN_REQUESTED',
  UPDATE_CAMPAIGN_STARTED = 'UPDATE_CAMPAIGN_STARTED',
  UPDATE_CAMPAIGN_SUCCEEDED = 'UPDATE_CAMPAIGN_SUCCEEDED',
  UPDATE_CAMPAIGN_FAILED = 'UPDATE_CAMPAIGN_FAILED',

  FETCH_LATEST_VARIABLESTATS_REQUESTED = 'FETCH_LATEST_VARIABLESTATS_REQUESTED',
  FETCH_LATEST_VARIABLESTATS_STARTED = 'FETCH_LATEST_VARIABLESTATS_STARTED',
  FETCH_LATEST_VARIABLESTATS_SUCCEEDED = 'FETCH_LATEST_VARIABLESTATS_SUCCEEDED',
  FETCH_LATEST_VARIABLESTATS_FAILED = 'FETCH_LATEST_VARIABLESTATS_FAILED',

  FETCH_EXPERIMENT_INTERFERENCE_REQUESTED = 'FETCH_EXPERIMENT_INTERFERENCE_REQUESTED',
  FETCH_EXPERIMENT_INTERFERENCE_STARTED = 'FETCH_EXPERIMENT_INTERFERENCE_STARTED',
  FETCH_EXPERIMENT_INTERFERENCE_SUCCEEDED = 'FETCH_EXPERIMENT_INTERFERENCE_SUCCEEDED',
  FETCH_EXPERIMENT_INTERFERENCE_FAILED = 'FETCH_EXPERIMENT_INTERFERENCE_FAILED',

  FETCH_EXPERIMENT_AVAILABILITY_REQUESTED = 'FETCH_EXPERIMENT_AVAILABILITY_REQUESTED',
  FETCH_EXPERIMENT_AVAILABILITY_STARTED = 'FETCH_EXPERIMENT_AVAILABILITY_STARTED',
  FETCH_EXPERIMENT_AVAILABILITY_SUCCEEDED = 'FETCH_EXPERIMENT_AVAILABILITY_SUCCEEDED',
  FETCH_EXPERIMENT_AVAILABILITY_FAILED = 'FETCH_EXPERIMENT_AVAILABILITY_FAILED',

  FETCH_EXPERIMENT_ANALYSIS_CONFIG_REQUESTED = 'FETCH_EXPERIMENT_ANALYSIS_CONFIG_REQUESTED',
  FETCH_EXPERIMENT_ANALYSIS_CONFIG_STARTED = 'FETCH_EXPERIMENT_ANALYSIS_CONFIG_STARTED',
  FETCH_EXPERIMENT_ANALYSIS_CONFIG_SUCCEEDED = 'FETCH_EXPERIMENT_ANALYSIS_CONFIG_SUCCEEDED',
  FETCH_EXPERIMENT_ANALYSIS_CONFIG_FAILED = 'FETCH_EXPERIMENT_ANALYSIS_CONFIG_FAILED',

  FETCH_METRIC_GLOSSARY_REQUESTED = 'FETCH_METRIC_GLOSSARY_REQUESTED',
  FETCH_METRIC_GLOSSARY_STARTED = 'FETCH_METRIC_GLOSSARY_STARTED',
  FETCH_METRIC_GLOSSARY_SUCCEEDED = 'FETCH_METRIC_GLOSSARY_SUCCEEDED',
  FETCH_METRIC_GLOSSARY_FAILED = 'FETCH_METRIC_GLOSSARY_FAILED',

  FETCH_ANALYSIS_REPORT_REQUESTED = 'FETCH_ANALYSIS_REPORT_REQUESTED',
  FETCH_ANALYSIS_REPORT_STARTED = 'FETCH_ANALYSIS_REPORT_STARTED',
  FETCH_ANALYSIS_REPORT_SUCCEEDED = 'FETCH_ANALYSIS_REPORT_SUCCEEDED',
  FETCH_ANALYSIS_REPORT_FAILED = 'FETCH_ANALYSIS_REPORT_FAILED',

  SET_LOCAL_FLAGS = 'SET_LOCAL_FLAGS',

  SET_EXPERIMENT_COUNTRY = 'SET_EXPERIMENT_COUNTRY',

  SET_WHITELISTED_VARIABLES = 'SET_WHITELISTED_VARIABLES',

  CREATE_EXPERIMENT_TAGS_REQUESTED = 'CREATE_EXPERIMENT_TAGS_REQUESTED',
  CREATE_EXPERIMENT_TAGS_STARTED = 'CREATE_EXPERIMENT_TAGS_STARTED',
  CREATE_EXPERIMENT_TAGS_SUCCEEDED = 'CREATE_EXPERIMENT_TAGS_SUCCEEDED',
  CREATE_EXPERIMENT_TAGS_FAILED = 'CREATE_EXPERIMENT_TAGS_FAILED',

  FETCH_EXPERIMENT_TAGS_REQUESTED = 'FETCH_EXPERIMENT_TAGS_REQUESTED',
  FETCH_EXPERIMENT_TAGS_STARTED = 'FETCH_EXPERIMENT_TAGS_STARTED',
  FETCH_EXPERIMENT_TAGS_SUCCEEDED = 'FETCH_EXPERIMENT_TAGS_SUCCEEDED',
  FETCH_EXPERIMENT_TAGS_FAILED = 'FETCH_EXPERIMENT_TAGS_FAILED',

  FETCH_ALL_EXPERIMENT_TAGS_REQUESTED = 'FETCH_ALL_EXPERIMENT_TAGS_REQUESTED',
  FETCH_ALL_EXPERIMENT_TAGS_STARTED = 'FETCH_ALL_EXPERIMENT_TAGS_STARTED',
  FETCH_ALL_EXPERIMENT_TAGS_SUCCEEDED = 'FETCH_ALL_EXPERIMENT_TAGS_SUCCEEDED',
  FETCH_ALL_EXPERIMENT_TAGS_FAILED = 'FETCH_ALL_EXPERIMENT_TAGS_FAILED',

  FETCH_POPULATION_QUERY_REQUESTED = 'FETCH_POPULATION_QUERY_REQUESTED',
  FETCH_POPULATION_QUERY_STARTED = 'FETCH_POPULATION_QUERY_STARTED',
  FETCH_POPULATION_QUERY_SUCCEEDED = 'FETCH_POPULATION_QUERY_SUCCEEDED',
  FETCH_POPULATION_QUERY_FAILED = 'FETCH_POPULATION_QUERY_FAILED',
}
